import {Action} from '@ngrx/store';
import {ILobItem} from '../../../models/lob.model';

export enum LobActionsType {
  load = '[Lob] Load Lobs',
}

export class LobLoadAction implements Action {

  readonly type = LobActionsType.load;

  constructor(public payload: {lobs: ILobItem[]}) {}

}

export type LobActions = LobLoadAction;
